document.addEventListener('DOMContentLoaded', function() {
    const className = 'bodyScrolled';
    const page = document.querySelector('body');
  
    // Use the existing bodyScrollObserver div
    const headerScrollObserver = document.getElementById('bodyScrollObserver');
  
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (page.classList.contains(className)) {
            page.classList.remove(className);
          }
        } else {
          if (!page.classList.contains(className)) {
            page.classList.add(className);
          }
        }
      });
    });
  
    observer.observe(headerScrollObserver);
});